import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_pinkEye_redFlagSymptoms',
    label: 'Are you experiencing any of the following? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Unusually stiff neck', key: 'stiff_neck' },
        {
          value: 'Unusually severe headache or feeling confused',
          key: 'severe_headache_confused'
        },
        {
          value: 'Sudden vision change or vision loss',
          key: 'vision_change_loss'
        },
        { value: 'Sudden severe eye pain', key: 'severe_eye_pain' },
        { value: 'Eye injury', key: 'eye_injury' },
        {
          value: 'Swelling or redness around the eyelids WITH fever',
          key: 'swelling_redness_with_fever'
        },
        {
          value: 'Sensitivity to light (photophobia)',
          key: 'photophobia'
        },
        {
          value:
            'Blisters or rash on the eyelids, around the eye, or on the nose',
          key: 'blisters_rash_eyelids'
        },
        {
          value: 'Recent eye surgery (within the past 6 weeks)',
          key: 'recent_eye_surgery'
        },
        {
          value:
            'Recent exposure to chemicals, fumes, or irritants in the eyes',
          key: 'chemical_exposure'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_symptomDuration',
    label: 'How long have you had symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 24 hours', key: 'less_than_24_hours' },
        { value: '1–3 days', key: '1_to_3_days' },
        { value: '4–7 days', key: '4_to_7_days' },
        { value: 'More than 7 days', key: 'more_than_7_days' }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_eyesAffected',
    label: 'Which eyes are affected?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Only one eye', key: 'one_eye' },
        { value: 'Both eyes', key: 'both_eyes' },
        {
          value: 'Started in one eye, then spread to the other',
          key: 'spread_to_other'
        }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_symptoms',
    label: 'Which symptoms are you experiencing? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Mild fever (100.4–102°F)', key: 'mild_fever' },
        { value: 'Eye redness or itching', key: 'redness_itching' },
        {
          value: 'Clear or watery eye discharge',
          key: 'clear_watery_discharge'
        },
        {
          value: 'Thick discharge (yellow/green) that returns after wiping',
          key: 'thick_discharge'
        },
        {
          value: 'Eyelids stuck together in the morning',
          key: 'eyelids_stuck_morning'
        },
        { value: 'Gritty or "sandy" feeling', key: 'gritty_sandy' },
        { value: 'Sore throat or runny nose', key: 'sore_throat_runny_nose' }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_visionChanges',
    label: 'Have you noticed any changes in your vision?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        {
          value: 'Blurry vision that improves when discharge is wiped away',
          key: 'blurry_improves_when_wiped'
        },
        {
          value:
            'Blurry vision that does NOT improve when discharge is wiped away',
          key: 'blurry_does_not_improve'
        }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_contactLensHistory',
    label: 'Contact Lens History:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'I do not wear contact lenses', key: 'do_not_wear' },
        {
          value:
            'I wear contact lenses, but have not worn them in the last 7 days',
          key: 'not_worn_7_days'
        },
        {
          value:
            'I wore contact lenses within 7 days of my symptoms starting',
          key: 'wore_within_7_days'
        }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_closeContact',
    label:
      'Have you been in close contact with someone who has pink eye or a red eye in the last 14 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_seasonalAllergies',
    label: 'Do you have seasonal allergies (sneezing, itchy nose) right now?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_pinkEye_additionalComments'
    }
  },
  {
    field: 'zalud_pinkEye_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_pinkEye_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_pinkEye_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludPinkEyeQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
